import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { EQUIPMENT_TYPE as EquipmentType, BUSINESS_CASE as BusinessCase } from '../../../../../utils/constant.utils';
import { getVendorDetails, getAddresses, getUserLocation } from '../../order-request.functions';

import { actions } from 'react-redux-form';
import {
    //model
    wirelessChangeVendorModel
    //action
    , setUserLocation
    , resetWirelessChangeVendorForm
    , setVendorOptions
    , setAccountOptions
    , setPlanOptions
    , setOtherPlanOptions
    , setSimOptions
    , setDeviceOptions
    , setOrderOptions
    , setCountryOptions
    , setAddressOptions
    , setVendorDetails
    , setPlanDetails
    , setSubscriptionDetails
    , setServiceTypeDetails
    , setBusinessCaseOptions
    , setShowDeviceOptions
    , setDeviceAccessories
    , setShowPreferredAddress
    , setFormSubmitted
    , setCircuitType
    , setCircuitTypeDetail
    , setPurposeOfUseOptions
    , setPurposeOfUseDetail
    , setResetLoading
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-change-vendor.settings';
import add from 'date-fns/esm/add';

export const changeVendorModelAInitialState = wirelessChangeVendorModel;

const planDetailConst = {
    PlanId: 0
    , ComponentName: ''
    , ComponentCost: 0
    , ComponentDetails: ''
    , IsPrimary: false
}

const serviceTypeDetailConst = {
    EquipmentInventoryId: 0
    , OrderCost: 0
}

const circuitTypeDetailConst = {
    circuitTypeDetailId: 0
    , circuitTypeName: ''
    , circuitTypeDescription: ''
}

const defaultState = () => ({
    userLocation: {}
    , accountOptions: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , planOptions: []
    , circuitTypeOptions: []
    , purposeOfUseOptions: []
    , otherPlanOptions: []
    , simOptions: []
    , orderOptions: []
    , deviceOptions: []
    , countryOptions: []
    , addressOptions: []
    , businessCaseOptions: []
    , deviceAccessories: []
    , planComponentLis: []
    , vendorDetails: {
        Currency: ''
    }
    , planDetails: { ...planDetailConst }
    , circuitTypeDetails: { ...circuitTypeDetailConst }
    , serviceTypeDetail: { ...serviceTypeDetailConst }
    , subscription: {}
    , showDeviceOptions: false
    , showPreferredAddress: false
    , formSubmitted: false
    , isDevice: false
    , isPhoneAccessory: false
    , isAmending: false
    , isOther: false
    , purposeOfUseDetail: {
        purposeOfUseId: ''
        , purposeOfUseName: ''
        , purposeOfUseDescription: ''
    }
    , isResetLoading: false
});

const initialState = defaultState();

export const wirelessChangeVendorActions = {

    getChangeVendorFormData: () => (dispatch, state) => {
        const { requestTypeId } = state().createRequest;
        getUserLocation(dispatch, setUserLocation, requestTypeId);
        getCountries(dispatch, state);
    },

    onROBSubscripitionAutoSelect: (value, empId) => async (dispatch, state) => {

        const { wirelessChangeVendorFormA } = state().form;
        const { subscriptionList, isWirelineRequest, isRequestOnBehalf, requestOnBehalfData, requestTypeId } = state().createRequest;
        const { requestData } = state().requestDetail;

        let url = 'external/autosuggest/getAllDeviceSubscriptionSuggestions/';

        var res = await httpGet(url
            + empId + '/'
            + requestTypeId
            + '?val=' + encodeURIComponent(value));

        if (value === '') {
            resetWirelessChangeVendorModel(dispatch);
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            var obj = res.find(o => o['CircuitCode'] === value);
            if (obj != null && obj.CircuitId != wirelessChangeVendorFormA.circuitId) {
                resetWirelessChangeVendorModel(dispatch);
                dispatch(actions.change('wirelessChangeVendorFormA.circuitCode', value));
                dispatch(actions.change('wirelessChangeVendorFormA.circuitId', obj.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });
                dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
                getVendors(dispatch, obj, requestData.Location.CountryName);
            }
        }
    },

    onSubscriptionSelect: (value, propsName, objects, index) => (dispatch, state) => {
        const { wirelessChangeVendorFormA } = state().form;
        const { requestTypeId, takeActionCircuitId } = state().createRequest;

        if (value === '' || !propsName) {
            resetWirelessChangeVendorModel(dispatch);
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
           if(propsName) {
                var obj=null              
                if(objects !== null && objects !== undefined) {
                    if(index !== -1 && index !== undefined && index !== null) {
                        obj=objects[index]
                    }
                    else if(objects.length === 1) {
                        obj=objects.find(o => o[propsName] === value);
                    } 
                    else if (objects.length > 1) {
                        obj = objects.find(o => o[propsName] === value & o['CircuitId'] === takeActionCircuitId);
                    } 
                }
                if (obj != null && obj.CircuitId != wirelessChangeVendorFormA.circuitId) {
                    resetWirelessChangeVendorModel(dispatch);
                    dispatch(actions.change('wirelessChangeVendorFormA.circuitCode', value));
                    dispatch(actions.change('wirelessChangeVendorFormA.circuitId', obj.CircuitId));
                    dispatch(actions.change('wirelessChangeVendorFormA.mobileServiceModel', []));
                    dispatch(actions.change('wirelessChangeVendorFormA.accessoryDetailsModel', []));
                    dispatch(actions.change('wirelessChangeVendorFormA.countryCode', ''));
                    dispatch(actions.change('wirelessChangeVendorFormA.locationId', ''));
                    dispatch(actions.change('wirelessChangeVendorFormA.deliveryAddress', ''));
                    dispatch(actions.change('wirelessChangeVendorFormA.otherDeliveryAddress', ''));
                    dispatch(actions.change('wirelessChangeVendorFormA.countryCode', ''));
                    dispatch(actions.change('wirelessChangeVendorFormA.locationId', ''));
                    dispatch(actions.change('wirelessChangeVendorFormA.newVendorId', ''));
                    dispatch(actions.change('wirelessChangeVendorFormA.circuitTypeId', ''));
                    dispatch(actions.change('wirelessChangeVendorFormA.equipmentCatalogId', ''));
                    dispatch(actions.change('wirelessChangeVendorFormA.newPlanId', ''));
                    dispatch(actions.change('wirelessChangeVendorFormA.busJustiCodeDetailId', 0));
                    dispatch(actions.change('wirelessChangeVendorFormA.purposeOfUseDetailId', 0));
                    dispatch({ type: setDeviceAccessories, data: [] });
                    dispatch({ type: setSubscriptionDetails, data: obj });
                    dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
                    dispatch({ type: setShowPreferredAddress, data: false });

                    getUserLocation(dispatch, setUserLocation, requestTypeId);
                    //getVendors(dispatch, obj);
                    getOrderOptions(dispatch);
                    //getDeviceOptions(dispatch, obj.VendorDetailId);
                    getBusinessCases(dispatch);
                    getCountries(dispatch, state);
                    getPurposeOfUse(dispatch)
                }
           }
        }
    }
    , onVendorSelect: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));
        resetFieldsOnVendorSelect(dispatch, value, false);
    }
    , onOrderSelect: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessChangeVendorFormA.equipmentCatalogId', 0)); 
        dispatch({ type: setShowDeviceOptions, data: value > 1 });

    }
    , onPlanSelect: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch({ type: setPlanDetails, data: planDetailConst });
        dispatch({ type: setOtherPlanOptions, data: initialState.otherPlanOptions });
        getPlanDetails(dispatch, value);
    }
    , onOtherPlanSelect: (e) => async (dispatch, state) => {

        const { otherPlanOptions } = state().wirelessChangeVendorRequest;
        const { wirelessChangeVendorFormA } = state().form;
        var selectedObj = otherPlanOptions.find(x => x.PlanComponentId == e.target.value);
        var newOtherPlans = [...wirelessChangeVendorFormA.planDetailsModel];

        if (e.target.checked) {
            newOtherPlans.push(selectedObj);
        } else {

            const indexOfObject = wirelessChangeVendorFormA.planDetailsModel.findIndex(o => {
                return o.PlanComponentId == e.target.value;
            });

            newOtherPlans.splice(indexOfObject, 1);
        }

        dispatch(actions.change('wirelessChangeVendorFormA.planDetailsModel', newOtherPlans));
    }
    , onServiceTypeSelect: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessChangeVendorFormA.mobileServiceModel', []));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        getServiceTypeDetails(dispatch, value);

    }
    , onAccessorySelect: (e) => async (dispatch, state) => {

        const { deviceAccessories } = state().wirelessChangeVendorRequest;
        const { wirelessChangeVendorFormA } = state().form;
        var selectedObj = deviceAccessories.find(x => x.EquipmentInventoryId == e.target.value);
        var newAccessories = [...wirelessChangeVendorFormA.accessoryDetailsModel];

        if (e.target.checked) {
            newAccessories.push(selectedObj);
        } else {

            const indexOfObject = wirelessChangeVendorFormA.accessoryDetailsModel.findIndex(o => {
                return o.EquipmentInventoryId == e.target.value;
            });

            newAccessories.splice(indexOfObject, 1);
        }

        dispatch(actions.change('wirelessChangeVendorFormA.accessoryDetailsModel', newAccessories));
    }
    , onCountrySelect: (model, value) => (dispatch, state) => {

        const { countryOptions, subscription } = state().wirelessChangeVendorRequest;

        dispatch(actions.change(model, value));

        let country = countryOptions.find(o => o['Key'] === value).Value;
        dispatch(actions.change('wirelessChangeVendorFormA.country', country));

        dispatch(actions.change('wirelessChangeVendorFormA.locationId', ''));
        dispatch(actions.change('wirelessChangeVendorFormA.deliveryAddress', ''));

        getAddresses(dispatch, setAddressOptions, value, true);
        getVendors(dispatch, subscription, country);

    }
    , setRequestorAddress: () => (dispatch, state) => {

        const { showOtherAddress, userLocation, subscription } = state().wirelessChangeVendorRequest;
        const { requestOnBehalfData } = state().createRequest;

        var location = {
            ...userLocation
        };

        if (requestOnBehalfData.EmployeeId > 0) {
            location = {
                ...requestOnBehalfData.LocationModel
            };
        }

        getAddresses(dispatch, setAddressOptions, location.CountryCode, showOtherAddress);

        if (Object.keys(subscription).length > 0) {
            getVendors(dispatch, subscription, userLocation.CountryName);
        }

        dispatch(actions.change('wirelessChangeVendorFormA.country', location.CountryName));
        dispatch(actions.change('wirelessChangeVendorFormA.countryCode', location.CountryCode));
        dispatch(actions.change('wirelessChangeVendorFormA.locationId', location.LocationId));
        dispatch(actions.change('wirelessChangeVendorFormA.deliveryAddress', location.DeliveryAddress));
        dispatch(actions.change('wirelessChangeVendorFormA.otherDeliveryAddress', ''));
    }
    , onAddressSelect: (model, value) => (dispatch, state) => {
        const { addressOptions } = state().wirelessChangeVendorRequest;
        const deliveryAddress = addressOptions.length > 0 ? addressOptions.find(r => r.Key == value).Value : '';
        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessChangeVendorFormA.deliveryAddress', deliveryAddress));
        dispatch(actions.change('wirelessChangeVendorFormA.otherDeliveryAddress', ''));
        dispatch({ type: setShowPreferredAddress, data: value == 0 });

    }
    , submitRequest: () => async (dispatch, state) => {

        const { wirelessChangeVendorFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData, isUpdateRequest } = state().createRequest;
        const { subscription } = state().wirelessChangeVendorRequest;
        const { requestData } = state().requestDetail;

        let userData = getUserData();

        if (isRequestOnBehalf && requestOnBehalfData.EmployeeId != 0) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
        }

        if (isUpdateRequest){
            var data = {
                ChangeRequestModel: {
                    ...userData
                    , CircuitId: wirelessChangeVendorFormA.circuitId
                    , VendorDetailId: subscription.VendorDetailId
                    , PlanDetailsModel: wirelessChangeVendorFormA.planDetailsModel
                    , BusinessJustification: wirelessChangeVendorFormA.businessJustification
                    , AdditionalInformation: wirelessChangeVendorFormA.additionalInformation   
                    , OrderOptionId: wirelessChangeVendorFormA.orderOptionId
                    , PhoneCaseAccessory: wirelessChangeVendorFormA.isPhoneAccessory
                    , RequestTypeId: requestTypeId
                    , EquipmentInventoryId: wirelessChangeVendorFormA.mobileServiceModel[0].EquipmentInventoryId
                    , EquipmentInventory: wirelessChangeVendorFormA.mobileServiceModel[0].EquipmentModel
                    , EquipmentTypeId: wirelessChangeVendorFormA.mobileServiceModel[0].EquipmentTypeId
                    , accessoryDetailsModel: wirelessChangeVendorFormA.accessoryDetailsModel
                    , otherLocationAddress: wirelessChangeVendorFormA.otherDeliveryAddress
                    , PurposeId: wirelessChangeVendorFormA.purposeOfUseDetailId
                    , BusinessCaseId: wirelessChangeVendorFormA.busJustiCodeDetailId
                    , OrderId: requestData.Order.OrderId
                    , CircuitOrderId: requestData.CircuitOrderId
                    , CountryCode: wirelessChangeVendorFormA.countryCode
                    , BillingLocationAddressId: wirelessChangeVendorFormA.locationId
                    , OrderInfoId: requestData.OrderInfoId
                     
                }
                ,...wirelessChangeVendorFormA
                , IsAmending: true
            };
        }
        else {
            var data = {
                ChangeRequestModel: {
                    ...userData
                    , CircuitId: wirelessChangeVendorFormA.circuitId
                    , VendorDetailId: subscription.VendorDetailId
                    , PlanDetailsModel: wirelessChangeVendorFormA.planDetailsModel
                    , BusinessJustification: wirelessChangeVendorFormA.businessJustification
                    , AdditionalInformation: wirelessChangeVendorFormA.additionalInformation
                    , OrderOptionId: wirelessChangeVendorFormA.orderOptionId
                    // , EquipmentCatalogId: wirelessChangeVendorFormA.equipmentCatalogId
                    , PhoneCaseAccessory: wirelessChangeVendorFormA.isPhoneAccessory
                    , RequestTypeId: requestTypeId
                    , EquipmentInventoryId: wirelessChangeVendorFormA.mobileServiceModel[0].EquipmentInventoryId
                    , EquipmentInventory: wirelessChangeVendorFormA.mobileServiceModel[0].EquipmentModel
                    , EquipmentTypeId: wirelessChangeVendorFormA.mobileServiceModel[0].EquipmentTypeId
                    , accessoryDetailsModel: wirelessChangeVendorFormA.accessoryDetailsModel
                    , otherLocationAddress: wirelessChangeVendorFormA.otherDeliveryAddress
                    , PurposeId: wirelessChangeVendorFormA.purposeOfUseDetailId
                    , BusinessCaseId: wirelessChangeVendorFormA.busJustiCodeDetailId
                    , CountryCode: wirelessChangeVendorFormA.countryCode
                    , BillingLocationAddressId: wirelessChangeVendorFormA.locationId             
                }
                ,...wirelessChangeVendorFormA
            };
        }

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/changeVendor/submitChangeVendor', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
    , onCircuitTypeSelect: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessChangeVendorFormA.circuitTypeId', value));
        dispatch(actions.change('wirelessChangeVendorFormA.equipmentCatalogId', 0));
        dispatch(actions.change('wirelessChangeVendorFormA.newPlanId', 0));
        dispatch(actions.change('wirelessChangeVendorFormA.planDetailsModel', []));
        getCircuitTypeDetails(dispatch, value);
        getDeviceOptions(dispatch, state, value);
        getPlans(dispatch, state, value);
    }

    , onPhoneAccessoryTick: (value) => (dispatch, state) =>{
        dispatch(actions.change('wirelessChangeVendorFormA.isPhoneAccessory', value));
    }

    , onPurposeOfUseSelect: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessChangeVendorFormA.purposeOfUseDetailId', value));
        getPurposeOfUseDetails(dispatch, value);
    }

    , onBusinessCaseSelect: (model, value) => (dispatch, state) => {
        const { businessCaseOptions } = state().wirelessChangeVendorRequest;
        var selectedBusinessCase = getOption(value, businessCaseOptions);
        dispatch(actions.change('wirelessChangeVendorFormA.busJustiCodeDetailId', value));
        dispatch(actions.change('wirelessChangeVendorFormA.businessJustification', ''));
        getBusinessCaseDetails(dispatch, selectedBusinessCase);
    }

    , resetWirelessChangeVendorForm: (isResetRequestOnBehalf = false) => (dispatch, state) => {

        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }
        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelessChangeVendorFormA.circuitCode'));
            dispatch(actions.reset('wirelessChangeVendorFormA.circuitId'));
            dispatch({ type: setSubscriptionDetails, data: {} });
            getCountries(dispatch, state);

            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }
        else if (!isResetRequestOnBehalf) {
            dispatch(actions.reset('wirelessChangeVendorFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }

        dispatch(actions.reset('wirelessChangeVendorFormA'));
        dispatch({ type: setShowDeviceOptions, data: false });
        dispatch({ type: setFormSubmitted, data: false });
    }
    , onUpdateAutoPopulate: (data, isRequestedInBehalf) => (dispatch, state) => {
        const { requestTypeId, subscriptionList, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { requestData } = state().requestDetail;
        const { subscription } = state().wirelessChangeVendorRequest;

        dispatch({ type: setDeviceAccessories, data: [] });

        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch({ type: setShowPreferredAddress, data: false });

        getUserLocation(dispatch, setUserLocation, requestTypeId);
        getOrderOptions(dispatch);
        getBusinessCases(dispatch);
        getCountries(dispatch, state);
        getPurposeOfUse(dispatch)
        getAddresses(dispatch, setAddressOptions, requestData.BillingAddress.CountryCode, true)
        getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, requestData.NewRequest.Vendor.VendorDetailId);
        getCircuitTypes(dispatch);
        getCircuitTypeDetails(dispatch, requestData.NewRequest.CircuitTypeId);
        getDeviceOptions(dispatch, state, requestData.NewRequest.CircuitTypeId);
        getPlans(dispatch, state, requestData.NewRequest.CircuitTypeId);
        getServiceTypeDetails(dispatch, requestData.Subscription.MobileServiceModel[0].EquipmentInventoryId);
        getPlanDetails(dispatch, requestData.NewRequest.PlanDetails.PlanId);
        getPurposeOfUseDetails(dispatch, requestData.BusinessJustification.PurposeOfUseId);

        if(!isRequestedInBehalf){
            getVendors(dispatch, subscriptionList[0], requestData.Location.CountryName);
            dispatch({ type: setSubscriptionDetails, data: subscriptionList[0] });
            dispatch(actions.change('wirelessChangeVendorFormA.circuitCode', requestData.Circuit.CircuitCode));
            dispatch(actions.change('wirelessChangeVendorFormA.circuitId', requestData.Circuit.CircuitId));
        }

        dispatch(actions.change('wirelessChangeVendorFormA.countryCode', requestData.BillingAddress.CountryCode));
        dispatch(actions.change('wirelessChangeVendorFormA.country', requestData.BillingAddress.CountryName));
        dispatch(actions.change('wirelessChangeVendorFormA.locationId', requestData.BillingAddress.LocationId));
        dispatch(actions.change('wirelessChangeVendorFormA.deliveryAddress', requestData.BillingAddress.DeliveryAddress));
        dispatch(actions.change('wirelessChangeVendorFormA.otherDeliveryAddress', requestData.BillingAddress.OtherDeliveryAddress));
        dispatch(actions.change('wirelessChangeVendorFormA.otherDeliveryAddressId', requestData.BillingAddress.OtherDeliveryAddressId));
        dispatch(actions.change('wirelessChangeVendorFormA.newVendorId', requestData.NewRequest.Vendor.VendorDetailId));
        dispatch(actions.change('wirelessChangeVendorFormA.circuitTypeId', requestData.NewRequest.CircuitTypeId));
        dispatch(actions.change('wirelessChangeVendorFormA.equipmentCatalogId', requestData.Subscription.MobileServiceModel[0].EquipmentInventoryId));
        dispatch(actions.change('wirelessChangeVendorFormA.newPlanId', requestData.NewRequest.PlanDetails.PlanId));
        dispatch(actions.change('wirelessChangeVendorFormA.isPhoneAccessory', requestData.Subscription.PhoneCaseAccessory));
        dispatch(actions.change('wirelessChangeVendorFormA.purposeOfUseDetailId', requestData.BusinessJustification.PurposeOfUseId));
        dispatch(actions.change('wirelessChangeVendorFormA.busJustiCodeDetailId', requestData.BusinessJustification.BusJustiCodeDetailId));
        dispatch(actions.change('wirelessChangeVendorFormA.businessJustification', requestData.BusinessJustification.BusinessJustification));
        dispatch(actions.change('wirelessChangeVendorFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation));
    }

}

function getOption(value, options) {
    return options.find(function (d) {
        return d.Key == value;
    });
}

function resetFieldsOnVendorSelect(dispatch, value, isUpdateRequest) {
    if (!isUpdateRequest) {
        dispatch(actions.change('wirelessChangeVendorFormA.newAccountId', 0));
        dispatch(actions.change('wirelessChangeVendorFormA.planDetailsModel', []));
        dispatch(actions.change('wirelessChangeVendorFormA.newPlanId', 0));

        //Clear options
        dispatch({ type: setPlanDetails, data: planDetailConst });
        dispatch({ type: setAccountOptions, data: [] });
        dispatch({ type: setVendorDetails, data: { ...defaultState.vendorDetails } });
        dispatch({ type: setPlanOptions, data: [] });
        dispatch({ type: setOtherPlanOptions, data: initialState.otherPlanOptions });
        dispatch({ type: setSimOptions, data: [] });
    }

    //fetch new data options
    getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, value);
    //getDeviceAccessories(dispatch, value);
    getAccounts(dispatch, value);
    //getPlans(dispatch, value);
    getSimTypes(dispatch);
    getCircuitTypes(dispatch);
}


async function getBusinessCaseDetails(dispatch, selectedBusinessCase) {
    if(selectedBusinessCase.Value == BusinessCase.Other)
    {
        dispatch(actions.change('wirelessChangeVendorFormA.isOther', true));
    }
    else
    {
        dispatch(actions.change('wirelessChangeVendorFormA.businessJustification', selectedBusinessCase.Value));
    }
}

async function getPurposeOfUseDetails(dispatch, purposeOfUseId) {
    var res = await httpGet('external/changeVendor/getPurposeOfUseDetails/' + purposeOfUseId);
    if (res != null) {
        dispatch({ type: setPurposeOfUseDetail, data: res });
        dispatch(actions.change('wirelessChangeVendorFormA.purposeOfUseDetails', res));
    } else {
        dispatch({ type: setPurposeOfUseDetail, data: [] });
    }
}

async function getPurposeOfUse(dispatch) {
    var res = await httpPost('external/changeVendor/getPurposeOfUse');
    if (res != null) {
        dispatch({ type: setPurposeOfUseOptions, data: res });
    } else {
        dispatch({ type: setPurposeOfUseOptions, data: [] });
    }
}

async function getCircuitTypes(dispatch) {
    var res = await httpGet('external/orderRequest/getCircuitType');
    if (res != null) {
        dispatch({ type: setCircuitType, data: res });
    } else {
        dispatch({ type: setCircuitType, data: [] });
    }
}

async function getCircuitTypeDetails(dispatch, circuitTypeId) {
    var res = await httpGet('external/orderRequest/getCircuitTypeDetails/' + circuitTypeId);
    if (res != null) {
        dispatch({ type: setCircuitTypeDetail, data: res });
    } else {
        dispatch({ type: setCircuitTypeDetail, data: [] });
    }
}

async function getDeviceAccessories(dispatch, vendorId) {

    var res = await httpGet('external/orderRequest/getEquipmentData/' + vendorId + '/' + EquipmentType.Accessory);

    if (res != null && res.length > 0) {
        dispatch({ type: setDeviceAccessories, data: res });
    } else {
        dispatch({ type: setDeviceAccessories, data: [] });
    }
}

async function getServiceTypeDetails(dispatch, typeId) {

    var res = await httpGet('external/orderRequest/getMobileServiceTypeDetails/' + typeId);

    if (res != null && res.length > 0) {
        if(res[0].EquipmentTypeId == EquipmentType.Device)
        {
            dispatch(actions.change('wirelessChangeVendorFormA.isDevice', true));
        }
        else {
            dispatch(actions.change('wirelessChangeVendorFormA.isDevice', false));
        }
        dispatch({ type: setServiceTypeDetails, data: res[0] });
        dispatch(actions.change('wirelessChangeVendorFormA.mobileServiceModel', res));
    } else {
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch(actions.change('wirelessChangeVendorFormA.mobileServiceModel', []));
    }

}

async function getBusinessCases(dispatch) {
    var res = await httpPost('external/replaceDevice/getBusinessCases');

    if (res != null) {
        dispatch({ type: setBusinessCaseOptions, data: res });
    } else {
        dispatch({ type: setBusinessCaseOptions, data: { ...defaultState.businessCaseOptions } });
    }
}

async function getCountries(dispatch, state) {
    const { subscription } = state().wirelessChangeVendorRequest;
    var res = await httpPost('external/replaceDevice/getCountriesList');
    if (res != null) {
        if(res.length == 1)
        {
            let country = res[0].Value
            let countryCode = res[0].Key
            dispatch(actions.change('wirelessChangeVendorFormA.country', country));
            dispatch(actions.change('wirelessChangeVendorFormA.countryCode', countryCode));
           
            getAddresses(dispatch, setAddressOptions, countryCode, true);

            if (Object.keys(subscription).length > 0) {
                getVendors(dispatch, subscription, country);
            }
        }
        dispatch({ type: setCountryOptions, data: res });
    } else {
        dispatch({ type: setCountryOptions, data: { ...defaultState.countryOptions } });
    }
}

async function getVendors(dispatch, obj, country ) {
    if (obj === undefined || obj == null) return;

    var res = await httpGet('external/changeVendor/getVendors/'
        + obj.CircuitId + '/'
        + country + '/'
        + obj.VendorDetailId);

    if (res != null && res.ok !== false) {
        dispatch({ type: setVendorOptions, prefVendors: res.PrefVendors, nonPrefVendors: res.NonPrefVendors });

        if (res.PrefVendors.length == 1) {
            dispatch(actions.change('wirelessChangeVendorFormA.newVendorId', res.PrefVendors[0].Key));
            resetFieldsOnVendorSelect(dispatch, res.PrefVendors[0].Key, true);
        }

    } else {
        dispatch({ type: setVendorOptions, prefVendors: [], nonPrefVendors: [] });
    }
}

async function getPlans(dispatch, state, circuitTypeId) {
    const { wirelessChangeVendorFormA } = state().form;
    const { requestData } = state().requestDetail;
    var newVendorId = wirelessChangeVendorFormA.newVendorId != null && wirelessChangeVendorFormA.newVendorId != "" ? wirelessChangeVendorFormA.newVendorId : requestData.NewRequest.Vendor.VendorDetailId;
    var res = await httpGet('external/orderRequest/getPlanByVendorByCircuitType/' + newVendorId + '/' + circuitTypeId);
    if (res != null) {
        dispatch({ type: setPlanOptions, data: res });
    } else {
        dispatch({ type: setPlanOptions, data: [] });
    }
}
// async function getPlanDetails(dispatch, planId) {
//     dispatch(actions.change('wirelessChangeVendorFormA.planDetailsModel', []));
//     var res = await httpGet('external/orderRequest/getPlanComponentByPlan/' + planId);
//     if (res != null) {
//         dispatch(actions.change('wirelessChangeVendorFormA.planComponentList', res[0]));
//     } else {
//         dispatch({ type: setPlanDetails, data: planDetailConst });
//         dispatch({ type: setOtherPlanOptions, data: initialState.otherPlanOptions });
//     }
// }

async function getPlanDetails(dispatch, planId) {
    dispatch(actions.change('wirelessChangeVendorFormA.planDetailsModel', []));
    var res = await httpGet('external/orderRequest/getPlanComponentByPlan/' + planId);
    if (res != null) {
        dispatch(actions.change('wirelessChangeVendorFormA.planComponentList', res.datatable));
        dispatch(actions.change('wirelessChangeVendorFormA.planDetailsModel', res.datatable[0].dataItem));
        dispatch({
                type: setPlanDetails,
                data: res.datatable[0].dataItem[0]
            });
    } else {
        dispatch({ type: setPlanDetails, data: planDetailConst });
        dispatch({ type: setOtherPlanOptions, data: initialState.otherPlanOptions });
    }
}

async function getAccounts(dispatch, id) {
    var res = await httpGet('external/orderRequest/getAccountByVendor/' + id);

    if (res != null && res.length > 0) {
        dispatch(actions.change('wirelessChangeVendorFormA.newAccountId', res[0].Key));
        dispatch({ type: setAccountOptions, data: res });
    } else {
        dispatch(actions.change('wirelessChangeVendorFormA.newAccountId', 0));
        dispatch({ type: setAccountOptions, data: [] });
    }
}

async function getSimTypes(dispatch) {
    var res = await httpPost('external/replaceSim/getSimType');
    if (res != null && res.length > 0) {
        dispatch(actions.change('wirelessChangeVendorFormA.newSimTypeId', res[0].Key));
        dispatch({ type: setSimOptions, data: res });
    } else {
        dispatch(actions.change('wirelessChangeVendorFormA.newSimTypeId', 0));
        dispatch({ type: setSimOptions, data: [] });
    }
}

async function getOrderOptions(dispatch) {
    var res = await httpPost('external/orderRequest/getAllOrderOptions');
    if (res != null) {
        dispatch({ type: setOrderOptions, data: res });
    } else {
        dispatch({ type: setOrderOptions, data: defaultState.orderOptions });
    }
}

async function getDeviceOptions(dispatch, state, circuitTypeId) {

    const { wirelessChangeVendorFormA } = state().form;
    const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
    const { requestData } = state().requestDetail;
    var newVendorId = wirelessChangeVendorFormA.newVendorId != null && wirelessChangeVendorFormA.newVendorId != "" ? wirelessChangeVendorFormA.newVendorId : requestData.NewRequest.Vendor.VendorDetailId ;
    let userData = getUserData().employeeID;
    if(isRequestOnBehalf && requestOnBehalfData.EmployeeId != 0){
        userData = requestOnBehalfData.EmployeeId;
    }
    var res = await httpGet(`external/orderRequest/getAllMobileServiceTypes/${newVendorId}/${circuitTypeId}/${userData}`);
    if (res != null) {
        dispatch({ type: setDeviceOptions, data: res });
    }
    else {
        dispatch({ type: setDeviceOptions, data: defaultState.deviceOptions });
    }
}

function resetWirelessChangeVendorModel(dispatch) {
    dispatch(actions.reset('wirelessChangeVendorFormA'));
    dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
    dispatch({ type: setDeviceAccessories, data: [] });
    dispatch({ type: setOtherPlanOptions, data: initialState.otherPlanOptions });
    dispatch({ type: resetWirelessChangeVendorForm, planDetailsModel: planDetailConst });
    dispatch({ type: setDeviceOptions, data: defaultState.deviceOptions });
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case resetWirelessChangeVendorForm:
            return {
                ...state,
                accountOptions: []
                , planOptions: []
                , preferredVendorOptions: []
                , nonPrefVendorOptions: []
                , simOptions: []
                , planDetails: { ...action.planDetailsModel }
                , vendorDetails: { ...{ Currency: '' } }
            };
        case setUserLocation:
            return {
                ...state,
                userLocation: action.data
            };
        case setVendorOptions:
            return {
                ...state
                , preferredVendorOptions: action.prefVendors
                , nonPrefVendorOptions: action.nonPrefVendors
            };
        case setAccountOptions:
            return {
                ...state
                , accountOptions: action.data
            };
        case setPlanOptions:
            return {
                ...state
                , planOptions: action.data
            };
        case setOtherPlanOptions:
            return {
                ...state,
                otherPlanOptions: action.data
            };
        case setSimOptions:
            return {
                ...state
                , simOptions: action.data
            };
        case setOrderOptions:
            return {
                ...state,
                orderOptions: action.data
            };
        case setDeviceOptions:
            return {
                ...state,
                deviceOptions: action.data
            };
        case setCountryOptions:
            return {
                ...state
                , countryOptions: action.data
            };
        case setAddressOptions:
            return {
                ...state,
                addressOptions: action.data
            };
        case setVendorDetails:
            return {
                ...state
                , vendorDetails: { ...action.data }
            };
        case setPlanDetails:
            return {
                ...state
                , planDetails: { ...action.data }
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setServiceTypeDetails:
            return {
                ...state,
                serviceTypeDetail: action.data
            };
        case setBusinessCaseOptions:
            return {
                ...state
                , businessCaseOptions: action.data
            };
        case setShowDeviceOptions:
            return {
                ...state,
                showDeviceOptions: action.data
            };
        case setDeviceAccessories:
            return {
                ...state,
                deviceAccessories: action.data
            };
        case setShowPreferredAddress:
            return {
                ...state,
                showPreferredAddress: action.data
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case setCircuitType:
            return {
                ...state
                , circuitTypeOptions: action.data
            };
        case setCircuitTypeDetail:
            return {
                ...state
                , circuitTypeDetails: { ...action.data }
            };
        case setPurposeOfUseOptions:
            return {
                ...state
                , purposeOfUseOptions: action.data
            };
        case setPurposeOfUseDetail:
            return {
                ...state
                , purposeOfUseDetail: { ...action.data}
            };
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            }  
        default: return state;
    }
}